/**
 * Corpus helpers for Voice generation prompts.
 */

import type { VoiceCorpusDocument, WorkspaceVoice } from './types';
import { listCorpusDocuments } from './voiceService';

export async function loadVoiceCorpusForPrompt(
  voiceId: string,
  limit = 12,
): Promise<VoiceCorpusDocument[]> {
  const { data } = await listCorpusDocuments(voiceId, limit);
  return data;
}

export function formatCorpusForPrompt(docs: VoiceCorpusDocument[]): string {
  if (docs.length === 0) return '(No corpus documents available.)';
  return docs
    .map((d, i) => {
      const ref = d.externalRef ? ` [${d.externalRef}]` : '';
      const when = d.occurredAt ? ` (${d.occurredAt.slice(0, 10)})` : '';
      return `${i + 1}.${ref}${when} ${d.title}\n${d.body}`;
    })
    .join('\n\n');
}

export function voiceCorpusLabel(voice: WorkspaceVoice): string {
  if (voice.corpusKind === 'support_tickets') return 'support tickets';
  if (voice.corpusKind === 'crm_pipeline') return 'CRM / sales pipeline';
  return 'constituency corpus';
}
